export default {
    TAKING_ORDERS: 'TAKING ORDERS',
    TEMPORARY_OUT_OF_USE: 'TEMPORARILY OUT OF USE',
    CLOSED: 'CLOSED',
    OUT_OF_ORDER: 'OUT OF ORDER',
    AVAILABLE: 'AVAILABLE',
    UNAVAILABLE: 'UNAVAILABLE',
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING',
    EXPIRED: 'EXPIRED',
    INACTIVE: 'INACTIVE',
    YES: 'YES',
    NO: 'NO',
    COMPLETED: 'COMPLETED',
    ACCEPTED: 'ACCEPTED',
    IN_DELIVERY: 'IN DELIVERY',
    REJECTED: 'REJECTED',
    CANCELLED: 'CANCELLED',
    SUCCESS: 'SUCCESS',
    NOT_INITIATED: 'NOT INITIATED',
    FAILED: 'FAILED',
};
